import type * as lazyIndex from "./lazyIndex";
export { default as loadTableViewFromTableQuery } from "./actions/loadTableViewFromTableQuery";
export { default as prefetchPriorityTableView } from "./actions/prefetchPriorityTableView";
export { default as selectPrefetchedTableView } from "./actions/selectPrefetchedTableView";
export { setTableViewErrorStateMutator } from "./actions/onInitialTableLoadComplete";
import "./orchestrators/loadTableViewFromSearchTableQueryOrchestrator";
import "./orchestrators/loadMessageSuggestionIntoTableOrchestrator";
import "./orchestrators/selectFocusedViewFilterOrchestrator";
import "./orchestrators/initializeLazyImports";
import { onListViewTypeOptionSaved } from "owa-options-actions/lib/onListViewTypeOptionSaved";
import { loadGenWebQueryOnTypeResults } from "owa-mail-search/lib/actions/publicActions";

import { needsReplyViewCloseRequested } from "owa-mail-actions";
import { LazyModule, LazyAction, registerLazyOrchestrator } from "owa-bundling";
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName:"TableLoading" */ "./lazyIndex"), { name: "mail/packages/mail/orchestration/owa-mail-table-loading-actions" });

registerLazyOrchestrator(onListViewTypeOptionSaved, lazyModule, m => m.onListViewTypeOptionSavedOrchestrator);

registerLazyOrchestrator(needsReplyViewCloseRequested, lazyModule, m => m.needsReplyViewCloseRequestedOrchestrator);

registerLazyOrchestrator(loadGenWebQueryOnTypeResults, lazyModule, m => m.loadGenWebQueryOnTypeResultsOrchestrator);

export const lazyDismissCopilotResultsTable: LazyAction<typeof lazyIndex.dismissCopilotResultsTable, typeof lazyModule> = new LazyAction(lazyModule, m => m.dismissCopilotResultsTable);

export const lazySwitchToCopilotResultsTable: LazyAction<typeof lazyIndex.switchToCopilotResultsTable, typeof lazyModule> = new LazyAction(lazyModule, m => m.switchToCopilotResultsTable);

export const lazySwitchToPreviousTable: LazyAction<typeof lazyIndex.switchToPreviousTable, typeof lazyModule> = new LazyAction(lazyModule, m => m.switchToPreviousTable);

export const lazySwitchToSearchResultsTable: LazyAction<typeof lazyIndex.switchToSearchResultsTable, typeof lazyModule> = new LazyAction(lazyModule, m => m.switchToSearchResultsTable);
